import styles from "./JustificationsList.module.css";
import { JustificationsListItem } from "./JustificationsListItem";

export const JustificationsList = ({ justs, rowObj }) => {
	return (
		<div className={styles.wrapper}>
			{justs?.map(({ id, file_name }) => (
				<JustificationsListItem key={id} justId={id} fileName={file_name} rowObj={rowObj} />
			))}
		</div>
	);
};
